import { FC, ReactElement } from 'react';
import { compose } from 'recompose';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';

import {
  withGroupIcons,
  withClientDepartments,
  withClientLocations,
  IWithClientDepartments,
  IWithClientLocations,
  IWithGroupIcons,
} from 'providers/queries';

interface IProps {
  children: ReactElement;
}

interface IPropsEnhanced
  extends IProps,
    IWithGroupIcons,
    IWithClientDepartments,
    IWithClientLocations,
    WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    '@global body': {
      backgroundColor: theme.palette.common.white,
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(
  withClientDepartments,
  withClientLocations,
  withGroupIcons,
  withStyles(styles),
);

const GroupController: FC<IPropsEnhanced> = props => props.children;

export default enhancers(GroupController);
